
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, ButtonToolbar, Button } from 'react-bootstrap';
import { PROPOSALS, EDIT_PROPOSAL, ADD_PROPOSAL_PRODUCT, ADD_PROPOSAL_PARTNER } from "./routes";
import ModuleHeader from '../../components/ModuleHeader';
import { proposalOperations, proposalSelectors } from './state';
import { orderPatternOperations } from "../OrderPattern/state";
import {
    MODE_EDIT, MODE_ADD, ERROR, EMPTY_STRING, MODE_COPY,
    RED, SHORT_TRUE, SHORT_FALSE, EMPTY_COUNT, GREEN,
    FIELD_PROPOSAL_STARTDATE, FIELD_PROPOSAL_ENDDATE, MIN_DB_DATE_EXACT, 
    MAX_DB_DATE_EXACT, MIN_TIME_LENGTH, PREFIX_HOUR
    , KANA_NO, KANA_YES, PROPOSAL_ID, AZ_az_09, DATE_FORMAT
} from '../../../utils/constants';
import 'react-datepicker/dist/react-datepicker.css';
import ProposalForm from './ProposalForm';
import { ERROR_PROPOSAL_NOT_EXIST, ERROR_REGISTRATION, SUCCESS_PROPOSAL_REGISTRATION, ERROR_PRODUCTLIST_EMPTY, ERROR_DATE_CONFLICT, ERROR_ORDER_CONFLICT, CONFIRMATION_DELETE, ERROR_PROPOSAL_RETRIEVE, ERROR_PROPOSAL_DELETE, SUCCESS_PROPOSAL_PRODUCT_REGISTRATION } from '../../../utils/messages';
import TableTemplate from '../../components/TableTemplate';
import { isNullOrUndefined } from '../../../../node_modules/util';
import moment from 'moment';
import ErrorAlert from '../../components/ErrorAlert';
import SuccessAlert from '../../components/SuccessAlert';
import Confirmation from '../../components/Confirmation';
import Loader from '../../components/Loader';
import $ from 'jquery';

class ViewProposal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            promptDelete:false,
            invalidProposal: false,
            proposalId: EMPTY_STRING,
            proposalName: EMPTY_STRING,
            proposalStartDate: MIN_DB_DATE_EXACT,
            proposalEndDate: MAX_DB_DATE_EXACT,
            requireShipping: true,
            displayPrice: EMPTY_STRING,
            monFlag: true,
            tueFlag: true,
            wedFlag: true,
            thuFlag: true,
            friFlag: true,
            satFlag: true,
            sunFlag: true,
            deadlineDay: 1,
            deadlineHour: EMPTY_STRING,
            deadlineMinute: EMPTY_STRING,
            remarks: EMPTY_STRING,
            productList: [],
            partnerList: [],
            isUpdateAllowed: false,
            registrationMessage: EMPTY_STRING,
            registrationColor: EMPTY_STRING,
            partnerMessage: EMPTY_STRING,
            deleteAction: this.deleteProposal.bind(this),
            error: [],
            success: [],
            loading: false
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        this.props.fetchPatterns();

        let id = this.props.match.params.id;

        if (undefined !== id) {
            this.setState({ mode: MODE_EDIT, loading: true, registrationMessage: EMPTY_STRING });

            this.getData(id, MODE_EDIT);

            if (undefined !== this.props.location.state) {
                this.setState({ 
                    isUpdateAllowed: this.props.location.state.allowUpdate,
                    success: this.props.location.state.success
                });
            }

        } else if (undefined !== this.props.location.state) {
            let copied = this.props.location.state.copied;
            this.getData(copied, MODE_COPY);
        } else {
            this.setState({
                mode: MODE_ADD
            });
        }
    }

    handleDateChangeRaw = (e) => {
        if (EMPTY_STRING !== e.target.value) {
            this.setState({ [e.target.name]: e.target.value })
        } else if (FIELD_PROPOSAL_STARTDATE === e.target.name) {
            this.setState({ [e.target.name]: MIN_DB_DATE_EXACT })
        } else if (FIELD_PROPOSAL_ENDDATE === e.target.name) {
            this.setState({ [e.target.name]: MAX_DB_DATE_EXACT })
        }
    }

    handleInputChange = (event) => {
        if(EMPTY_STRING === event.target.value || PROPOSAL_ID !== event.target.name || (PROPOSAL_ID === event.target.name && (event.target.value.match(AZ_az_09)))){
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    handleSubmit = () => {
        let errorList = proposalSelectors.validateForm(this.state);

        if (EMPTY_COUNT < errorList.length) {
            if (!this.state.invalidProductClass) {
                this.setState({ error: errorList, success: [] });
            }
        } else {
            this.props.checkDateConflict(this.state.proposalId, this.state.proposalStartDate, this.state.proposalEndDate).then((result) => {
                if (result.data && (EMPTY_COUNT < result.data.orders.length || EMPTY_COUNT < result.data.conflicts.length)) {
                    let prompt = [];

                    if (EMPTY_COUNT < result.data.conflicts.length) {
                        prompt.push(ERROR_DATE_CONFLICT);
                        result.data.conflicts.map((item) => prompt.push("* " + item.proposalName + " - " + item.customerName));
                        EMPTY_COUNT < result.data.orders.length && prompt.push(EMPTY_STRING);
                    }

                    if (EMPTY_COUNT < result.data.orders.length) {
                        prompt.push(ERROR_ORDER_CONFLICT);
                        var i = 0;
                        var nohinDt;
                        for(i = 0; i < result.data.orders.length ; i++){
                            nohinDt = new Date(result.data.ordersDate[i]);
                            prompt.push("* 受注番号 " + result.data.orders[i] 
                            + " 納品日 " + nohinDt.getFullYear() + "/" 
                            + (nohinDt.getMonth() + 1 >= 10 ?  nohinDt.getMonth() + 1: "0" + (nohinDt.getMonth() + 1)) + "/" 
                            + (nohinDt.getDate() >= 10 ? nohinDt.getDate() : "0" + nohinDt.getDate()));
                        }
                    }

                    this.setState({ error: prompt, success: [] });
                } else {
                    this.setState({ error: [] });

                    let proposal = {
                        proposalId: this.state.proposalId,
                        proposalName: this.state.proposalName,
                        userCode: this.props.user.user_cd,
                        proposalStartDate: this.state.proposalStartDate,
                        proposalEndDate: this.state.proposalEndDate,
                        monFlag: this.state.monFlag ? SHORT_TRUE : SHORT_FALSE,
                        tueFlag: this.state.tueFlag ? SHORT_TRUE : SHORT_FALSE,
                        wedFlag: this.state.wedFlag ? SHORT_TRUE : SHORT_FALSE,
                        thuFlag: this.state.thuFlag ? SHORT_TRUE : SHORT_FALSE,
                        friFlag: this.state.friFlag ? SHORT_TRUE : SHORT_FALSE,
                        satFlag: this.state.satFlag ? SHORT_TRUE : SHORT_FALSE,
                        sunFlag: this.state.sunFlag ? SHORT_TRUE : SHORT_FALSE,
                        displayPrice: this.state.displayPrice,
                        requireShipping: this.state.requireShipping ? SHORT_TRUE : SHORT_FALSE,
                        deadlineDay: this.state.deadlineDay,
                        deadlineTime: this.state.deadlineHour + this.state.deadlineMinute,
                        remarks: this.state.remarks,
                        productList: this.state.productList
                    };

                    if (MODE_EDIT === this.state.mode) {
                        this.props.editProposal(proposal).then((result) => {
                            this.checkResult(result);
                        }).catch(()=>{this.setState({error: [ERROR_REGISTRATION]})});;
                    } else {
                        this.props.addProposal(proposal).then((result) => {
                            this.checkResult(result);
                        }).catch(()=>{this.setState({error: [ERROR_REGISTRATION]})});;
                    }
                }

            }).catch(()=>{this.setState({error: [ERROR_REGISTRATION]})});
        }
    }

    handleDateChange = (name, customFormat, date) => {
        if (!isNullOrUndefined(date)) {
            let formatDate = date.format(customFormat)
            this.setState({ [name]: formatDate })
        }
    }

    handleCheckboxChange = (event) => {
        this.setState({ [event.target.name]: !this.state[event.target.name] });
    }

    handlePriceChange = (e) => {
        let that = this;
        let input_id = e.target.id;
        this.setPrice(input_id, e.target.value);

        $(function() {
            $(`#${input_id}`).on('input', function() {
            
            this.value = this.value
                .replace(/[^\d.]/g, '')            
                .replace(/(^[\d]{10})[\d]/g, '$1')   
                .replace(/(\..*)\./g, '$1')       
                .replace(/(\.[\d]{2})./g, '$1');   
            
                let newPrice = Number(this.value);

                if (EMPTY_STRING === this.value) {
                    newPrice = null;
                }

                that.setPrice(input_id, newPrice);
            });
        });
    }

    setPrice = (id, value) =>{
        let newState = Object.assign({}, this.state);
        newState.productList[id].productPrice = value;
        this.setState(newState)
    }

    handlePatternChange = (e) => {
        let newPattern = Number(e.target.value);
        let newState = Object.assign({}, this.state);

        newState.productList[e.target.id].orderControlCode = newPattern;

        this.setState(newState);
    }

    getData = (id, mode) => {
        this.props.view(id).then((result) => {
            if (null === result.data.details) {
                this.setState({ error: [ERROR_PROPOSAL_NOT_EXIST], invalidProposal: true, isUpdateAllowed: false, success: [], loading: false });
            } else {
                let proposal = result.data.details;
                let products = result.data.products;
                let partners = (MODE_COPY === mode) ? [] : result.data.partners;
                let deadlineTime = MIN_TIME_LENGTH === proposal.deadlineTime.length ? PREFIX_HOUR + proposal.deadlineTime : proposal.deadlineTime;

                this.setState({
                    proposalId: MODE_COPY === mode ? EMPTY_STRING : proposal.proposalId,
                    proposalName: proposal.proposalName,
                    proposalStartDate: moment(proposal.proposalStartDate).format(DATE_FORMAT),
                    proposalEndDate: moment(proposal.proposalEndDate).format(DATE_FORMAT),
                    monFlag: proposal.monFlag,
                    tueFlag: proposal.tueFlag,
                    wedFlag: proposal.wedFlag,
                    thuFlag: proposal.thuFlag,
                    friFlag: proposal.friFlag,
                    satFlag: proposal.satFlag,
                    sunFlag: proposal.sunFlag,
                    displayPrice: proposal.displayPrice,
                    requireShipping: proposal.requireShipping,
                    deadlineDay: proposal.deadlineDay,
                    deadlineHour: proposalSelectors.hourSubtstring(deadlineTime),
                    deadlineMinute: proposalSelectors.minSubtstring(deadlineTime),
                    remarks: null === proposal.remarks ? EMPTY_STRING : proposal.remarks,
                    productList: products,
                    partnerList: partners,
                    isUpdateAllowed: MODE_EDIT === mode,
                    loading: false
                });
            }
        }).catch(() => {
            this.setState({ error: [ERROR_PROPOSAL_RETRIEVE], invalidProposal: true, isUpdateAllowed: false, success: [], loading: false });
        });
    }

    updateProposalProducts = () => {
        let productErrorMsg = proposalSelectors.validateProductTable(this.state.productList);

        if (EMPTY_COUNT < productErrorMsg.length) {
            this.setState({ registrationMessage: productErrorMsg, registrationColor: RED, partnerMessage: EMPTY_STRING });
        } else if (EMPTY_COUNT < this.state.productList.length) {
            this.props.updateProducts(this.state.productList, this.props.user.user_cd).then((result) => {
                if (ERROR === result.status) {
                    this.setState({ registrationMessage: ERROR_REGISTRATION, registrationColor: RED, partnerMessage: EMPTY_STRING });
                } else {
                    this.getData(this.state.proposalId, MODE_EDIT);
                    this.setState({ registrationMessage: SUCCESS_PROPOSAL_PRODUCT_REGISTRATION, registrationColor: GREEN });
                }
            })
        } else {
            this.setState({ registrationMessage: ERROR_PRODUCTLIST_EMPTY, registrationColor: RED, partnerMessage: EMPTY_STRING });
        }
    }

    deleteProposalProduct = (row) => {
        this.setState({ deleteAction:this.deleteProduct.bind(this, row), promptDelete:true})       
    }

    deleteProduct = (row) => {
        this.setState({promptDelete:false})
        this.props.deleteProduct({
            proposalId: row.proposalId,
            productCode: row.strProductCode
        }).then((result) => {
            if (ERROR === result.status) {
                this.setState({ registrationMessage: result.message, registrationColor: RED, partnerMessage: EMPTY_STRING });
            } else {
                this.setState({ registrationMessage: EMPTY_STRING, partnerMessage: EMPTY_STRING });
                this.getData(this.state.proposalId, MODE_EDIT);
            }
        })
    }

    deleteProposalPartner = (row) => {
        this.setState({ deleteAction:this.deletePartner.bind(this, row), promptDelete:true})       
    }

    deletePartner =(row)=>{
        this.setState({promptDelete:false})
        this.props.deletePartner({
            proposalId: row.proposalId,
            customerCode1: row.customerCode1,
            customerCode2: row.customerCode2
        }).then((result) => {
            if (ERROR === result.status) {
                this.setState({ partnerMessage: result.message, success: [], registrationMessage: EMPTY_STRING });
            } else {
                this.setState({ partnerMessage: EMPTY_STRING, success: [], registrationMessage: EMPTY_STRING });
                this.getData(this.state.proposalId, MODE_EDIT);
            }
        })
    }

    deleteProposal = () => {
        this.setState({promptDelete:false})
        if (!this.state.invalidProposal) {
            this.props.deleteProposal(this.state.proposalId).then((result) => {
                if (ERROR === result.status) {
                    this.setState({ error: [result.message], success: [], registrationMessage: EMPTY_STRING, partnerMessage: EMPTY_STRING });
                } else {
                    this.showList();
                }
            }).catch(()=>this.setState({error: [ERROR_PROPOSAL_DELETE]}));
        }
    }

    checkResult = (result) => {
        if (ERROR === result.status) {
            this.setState({ error: [result.message], success: [] });
        } else {
            if (MODE_EDIT === this.state.mode) {
                this.getData(this.state.proposalId, MODE_EDIT);
                this.setState({ isUpdateAllowed: true, success: [SUCCESS_PROPOSAL_REGISTRATION], registrationMessage: EMPTY_STRING, partnerMessage: EMPTY_STRING });
            } else {
                this.props.history.push({
                    pathname: EDIT_PROPOSAL + "/" + this.state.proposalId,
                    state: { allowUpdate: true, success: [SUCCESS_PROPOSAL_REGISTRATION] }
                });
            }
        }
    }


    showList = () => {
        this.props.history.push(PROPOSALS);
    }

    productAdd = () => {
        this.props.history.push({
            pathname: EDIT_PROPOSAL + "/" + this.state.proposalId + ADD_PROPOSAL_PRODUCT,
            state: { allowUpdate: true }
        });
    }

    partnerAdd = () => {
        this.props.history.push({
            pathname: EDIT_PROPOSAL + "/" + this.state.proposalId + ADD_PROPOSAL_PARTNER,
            state: { allowUpdate: true }
        });
    }

    formButtons() {
        if (MODE_EDIT === this.state.mode) {
            return [
                { label: "登録", disabled: !this.state.isUpdateAllowed, onClick: () => this.handleSubmit() },
                { label: "削除", disabled: !this.state.isUpdateAllowed, onClick: () => this.setState({deleteAction:this.deleteProposal,promptDelete:true}) },
                { label: "戻る", onClick: () => this.showList() }
            ]
        } else {
            return [
                { label: "登録", onClick: () => this.handleSubmit() },
                { label: "戻る", onClick: () => this.showList() }
            ]
        }
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <Loader customLoader={this.state.loading}/>
                    <ModuleHeader title={"商品提案グループ編集"} />

                    <ErrorAlert errors={this.state.error}/>
                    <SuccessAlert success={this.state.success}/>

                    <Col sm={12} className="proposal-input">
                        <ProposalForm
                            {...this.state}
                            {...this.props}
                            editMode={MODE_EDIT === this.state.mode}
                            handleDateChangeRaw={this.handleDateChangeRaw}
                            handleInputChange={this.handleInputChange}
                            handleCheckboxChange={this.handleCheckboxChange}
                            handleDateChange={this.handleDateChange}
                            formButtons={this.formButtons()}
                        />

                        <div className="flex-between">

                            <div className="flex-between">
                                <p className="table-label first">＜商品リスト＞</p>
                                <p className={RED === this.state.registrationColor ? "table-response text-red" : "table-response text-green"}>
                                    {this.state.registrationMessage}
                                </p>
                            </div>

                            <ButtonToolbar className="pull-right fixed-right table-actions">
                                <Button
                                    className="button-common"
                                    disabled={!this.state.isUpdateAllowed}
                                    onClick={() => this.updateProposalProducts()}>
                                    {"価格/発注制御パターン確定"}
                                </Button>

                                <Button
                                    className="button-common"
                                    disabled={!this.state.isUpdateAllowed}
                                    onClick={() => this.productAdd()}>
                                    {"商品リスト追加"}
                                </Button>
                            </ButtonToolbar>

                        </div>
                        <TableTemplate
                            tableName={"productProposalTable"}
                            tableList={this.state.productList}
                            tableHeader={this.props.productTableHeader}
                            tableColumns={this.props.productTableColumns}
                            handlePriceChange={this.handlePriceChange}
                            handlePatternChange={this.handlePatternChange}
                            isDisabled={!this.state.isUpdateAllowed}
                            selectInput={this.props.selectPatterns}
                            inputValues={this.state.productList}
                            selectPlaceholder={"<< 発注制御パターン >>"}
                            rowButtons={[
                                {
                                    onClick: this.deleteProposalProduct,
                                    icon: ['fas', "trash-alt"],
                                    bsStyle: "link"
                                },
                            ]}
                        />

                        <br /><br />
                        <div className="flex-between">
                            <div className="flex-between">
                                <p className="table-label">＜取引先リスト＞</p>
                                <p className={"table-response text-red"}>
                                    {this.state.partnerMessage}
                                </p>
                            </div>

                            <ButtonToolbar className="pull-right fixed-right table-actions">
                                <Button
                                    className="button-common"
                                    disabled={!this.state.isUpdateAllowed}
                                    onClick={() => this.partnerAdd()}>
                                    {"取引先リスト追加"}
                                </Button>
                            </ButtonToolbar>
                        </div>

                        <TableTemplate
                            tableName={"partnerProposalTable"}
                            tableList={this.state.partnerList}
                            tableHeader={this.props.partnerTableHeader}
                            tableColumns={this.props.partnerTableColumns}
                            isDisabled={!this.state.isUpdateAllowed}
                            rowButtons={[
                                {
                                    onClick: this.deleteProposalPartner,
                                    icon: ['fas', "trash-alt"],
                                    bsStyle: "link"
                                },
                            ]}
                        />
                    </Col>
                    <Confirmation
                        message={CONFIRMATION_DELETE}
                        showConfirmation={this.state.promptDelete}
                        buttons={[
                            { label: KANA_YES, action: this.state.deleteAction },
                            { label: KANA_NO, action: ()=>{this.setState({promptDelete:false})} }
                        ]}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        dayValues: state.proposal.dayValues,
        dayFlags: state.proposal.dayFlags,
        minuteValues: state.proposal.minuteValues,
        productTableHeader: state.proposal.productTableHeader,
        productTableColumns: state.proposal.productTableColumns,
        partnerTableHeader: state.proposal.partnerTableHeader,
        partnerTableColumns: state.proposal.partnerTableColumns,
        selectPatterns: state.orderPattern.select
    }
};
const mapDispatchToProps = {
    fetchPatterns: orderPatternOperations.fetchDefault,
    addProposal: proposalOperations.addProposal,
    editProposal: proposalOperations.editProposal,
    deleteProposal: proposalOperations.deleteProposal,
    view: proposalOperations.viewProposal,
    updateProducts: proposalOperations.updateProducts,
    deleteProduct: proposalOperations.deleteProduct,
    deletePartner: proposalOperations.deletePartner,
    checkDateConflict: proposalOperations.checkDateConflict
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProposal);